// Generate a palette for high-cardinality categories using hue + lightness steps

function hslToHex(h: number, s: number, l: number): string {
  h = ((h % 360) + 360) % 360; s = Math.max(0, Math.min(1, s)); l = Math.max(0, Math.min(1, l));
  const c = (1 - Math.abs(2 * l - 1)) * s;
  const x = c * (1 - Math.abs(((h / 60) % 2) - 1));
  const m = l - c / 2;
  let r = 0, g = 0, b = 0;
  if (h < 60) { r = c; g = x; b = 0; }
  else if (h < 120) { r = x; g = c; b = 0; }
  else if (h < 180) { r = 0; g = c; b = x; }
  else if (h < 240) { r = 0; g = x; b = c; }
  else if (h < 300) { r = x; g = 0; b = c; }
  else { r = c; g = 0; b = x; }
  const toHex = (v: number) => Math.round((v + m) * 255).toString(16).padStart(2,'0');
  return `#${toHex(r)}${toHex(g)}${toHex(b)}`;
}

export function generateHueLightnessPalette(count: number, baseSaturation = 0.65): string[] {
  const colors: string[] = [];
  if (count <= 0) return colors;
  const hueStep = 360 / Math.ceil(Math.min(count, 12));
  const lightnessBuckets = Math.ceil(count / Math.ceil(12));
  let produced = 0;
  for (let lStep = 0; produced < count; lStep++) {
    const lightness = 0.54 + ((lStep % 2 === 0 ? -1 : 1) * (Math.floor(lStep / 2) + 1)) * 0.08;
    const L = Math.max(0.3, Math.min(0.75, lightness));
    const ring = Math.min(12, count - produced);
    for (let i = 0; i < ring && produced < count; i++) {
      const h = (i * hueStep + (lStep * 11)) % 360;
      colors.push(hslToHex(h, baseSaturation, L));
      produced++;
    }
  }
  return colors;
}


